__turbopack_context__.v({
  "badge": "FeatureFlagOverlay-module-scss-module__WetC3W__badge",
  "btn-apply": "FeatureFlagOverlay-module-scss-module__WetC3W__btn-apply",
  "btn-reset": "FeatureFlagOverlay-module-scss-module__WetC3W__btn-reset",
  "container": "FeatureFlagOverlay-module-scss-module__WetC3W__container",
  "controls": "FeatureFlagOverlay-module-scss-module__WetC3W__controls",
  "flag-key": "FeatureFlagOverlay-module-scss-module__WetC3W__flag-key",
  "flag-meta": "FeatureFlagOverlay-module-scss-module__WetC3W__flag-meta",
  "flag-name": "FeatureFlagOverlay-module-scss-module__WetC3W__flag-name",
  "header": "FeatureFlagOverlay-module-scss-module__WetC3W__header",
  "input": "FeatureFlagOverlay-module-scss-module__WetC3W__input",
  "list": "FeatureFlagOverlay-module-scss-module__WetC3W__list",
  "overridden": "FeatureFlagOverlay-module-scss-module__WetC3W__overridden",
  "override-count": "FeatureFlagOverlay-module-scss-module__WetC3W__override-count",
  "panel": "FeatureFlagOverlay-module-scss-module__WetC3W__panel",
  "reset-all": "FeatureFlagOverlay-module-scss-module__WetC3W__reset-all",
  "row": "FeatureFlagOverlay-module-scss-module__WetC3W__row",
  "select": "FeatureFlagOverlay-module-scss-module__WetC3W__select",
  "server-value": "FeatureFlagOverlay-module-scss-module__WetC3W__server-value",
  "title": "FeatureFlagOverlay-module-scss-module__WetC3W__title",
  "toggle": "FeatureFlagOverlay-module-scss-module__WetC3W__toggle",
});
